import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { TotalFieldProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const TotalAmountTableFooter: React.FC<TotalFieldProps> = (props) => {
  return (
    <Grid container direction="row" className={cssExports.totalAmountFooter}>
      <label>{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Total)}:`}</label>
      <label className={cssExports.totalValue}>
        {LocalizationHelperInstance.getFormattedCurrency(props.value ?? 0, CurrencyEnums.CurrencyCode.SEK)}
      </label>
    </Grid>
  );
};

export default TotalAmountTableFooter;
